import Grid from '@components/Grid'
import Info from '@components/Info'
import MailResponse from '@components/MailResponse'
import Alert from '@components/UI/Alert'
import Button from '@components/UI/Button'
import Field, { FieldFeedback, FieldLabel } from '@components/UI/Field'
import Icon from '@components/UI/Icon'
import Input from '@components/UI/Input'
import Link from '@components/UI/Link'
import Loading from '@components/UI/Loading'
import Picture from '@components/UI/Picture'
import Select from '@components/UI/Select'
import css from '@utils/css'

import badge1 from '@images/badges-actual/badge1.svg'
import badge2 from '@images/badges-actual/badge2.svg'
import badge3 from '@images/badges-actual/badge3.svg'

import personalProductExpert from '@images/personal-product-expert.png'

import Navigation from '@layouts/Navigation/Traqq'
import { useRouter } from "next/router";
import { objectToFormData } from '@utils/form'
import RenderIf from '@utils/renderIf'

import React, { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import Reviews from './Reviews.jsx'

const organizationSizeOptions = [
    {
        name: '1',
        value: '1'
    },
    {
        name: '2 - 10',
        value: '2-10'
    },
    {
        name: '11 - 20',
        value: '11-20'
    },
    {
        name: '21 - 50',
        value: '21-50'
    },
    {
        name: '51 - 100',
        value: '51-100'
    },
    {
        name: '101 - 500',
        value: '101-500'
    },
    {
        name: '500+',
        value: '500+'
    }
]

const Demo = () => {
    const recaptchaRef = useRef(null)
    const router = useRouter();

    const [loading, setLoading] = useState(false)
    const [sent, setSent] = useState(false)
    const [response, setResponse] = useState({})
    const [errors, setErrors] = useState({})

    const handleSubmit = async (event) => {
        event.preventDefault()

        if (!loading) {
            setLoading(true)
            setSent(false)

            const formData = objectToFormData(event.target)
            formData.append('recaptcha', await recaptchaRef.current.executeAsync())

            try {
              const response = await fetch(
                `${process.env.NEXT_PUBLIC_APP_URL}/api/v1/request-demo`,
                {
                  body: formData,
                  // headers: {
                  //     'X-Requested-With': 'XMLHttpRequest',
                  //     'X-CSRF-TOKEN': token
                  // },
                  method: "POST",
                }
              );

              const status = response.status;

              if (status === 200) {
                const data = await response.json();

                if (data?.result == "success") {
                  setResponse(data.params);
                  setErrors({});
                  setSent(true);

                  event.target.reset();
                } else {
                  if (data?.data?.errors) {
                    setErrors(data.data.errors);
                  } else {
                    router.push("/400");
                  }
                }
              } else if (status === 400) {
                router.push("/400");
              } else if (status === 500) {
                router.push("/500");
              }
            } catch (error) {
              router.push("/500");
            }

            setLoading(false)
        }
    }

    return (
        <>
            <Navigation
                theme='dark'
                background='neutral'
            />

            <div className='bg-neutral-900'>
                <div className={ css(
                    'container',
                    'pt-16p pb-32p mb-48p',
                    '480:pt-24p',
                    '1024:pt-32p',
                    '1280:(pt-40p pb-72p mb-64p)'
                ) }>
                    <div
                        className={ css(
                            'flex flex-col rounded-16p bg-white px-24p pt-24p pb-32p gap-x-48p gap-y-32p items-start',
                            '480:(px-40p pt-32p pb-40p gap-y-48p)',
                            '768:(p-40p)',
                            '1024:(pt-32p pr-48p flex-row)',
                            '1280:(px-72p pt-48p pb-56p gap-x-88p items-end)'
                        ) }
                    >
                        <div
                            className={ css(
                                'demo__form',
                                '1024:(order-2 pt-16p)'
                            ) }
                        >
                            <Info
                                gap={ 4 }
                            >
                                <h1
                                    className='h2 768:desktop-heading-2'
                                >
                                    Ready to boost your team's performance? Let's talk!
                                </h1>

                                <p
                                    className='mobile-body-2 768:desktop-body-2'
                                >
                                    We at Traqq hate boring marketing presentations. Your business is unique, so let us save you precious time by not talking about how cool we are, but rather focusing on what your team needs. We'll show how Traqq is going to help YOU and your team. 😉
                                </p>
                            </Info>

                            <form
                                method='POST'
                                acceptCharset='UTF-8'
                                onSubmit={ handleSubmit }
                            >
                                <Grid
                                    xs={ 1 }
                                    md={ 2 }
                                    gx={ 6 }
                                >
                                    <Field>
                                        <FieldLabel
                                            htmlFor='fullName'
                                        >
                                            Full Name*
                                        </FieldLabel>

                                        <Input
                                            name='fullName'
                                            type='text'
                                            // placeholder='John Doe'
                                            id='fullName'
                                            mods={ { invalid: Boolean(errors.fullName) } }
                                            required
                                            inputProps={ { maxLength: 64 } }
                                        />

                                        <RenderIf
                                            isTrue={ errors.fullName }
                                        >
                                            <FieldFeedback
                                                invalid
                                            >
                                                { errors.fullName?.join('\n') }
                                            </FieldFeedback>
                                        </RenderIf>
                                    </Field>
                                    <Field>
                                        <FieldLabel
                                            htmlFor='organizationsName'
                                        >
                                            Organization’s Name*
                                        </FieldLabel>

                                        <Input
                                            name='organizationsName'
                                            type='text'
                                            // placeholder='Acme Ltd'
                                            id='organizationsName'
                                            mods={ { invalid: Boolean(errors.organizationsName) } }
                                            required
                                            inputProps={ { maxLength: 64 } }
                                        />

                                        <RenderIf
                                            isTrue={ errors.organizationsName }
                                        >
                                            <FieldFeedback
                                                invalid
                                            >
                                                { errors.organizationsName?.join('\n') }
                                            </FieldFeedback>
                                        </RenderIf>
                                    </Field>

                                    <Field>
                                        <FieldLabel
                                            htmlFor='email'
                                        >
                                            Work Email Address*
                                        </FieldLabel>

                                        <Input
                                            name='email'
                                            type='email'
                                            // placeholder='email@domain.com'
                                            id='email'
                                            mods={ { invalid: Boolean(errors.email) } }
                                            required
                                            inputProps={ { maxLength: 64 } }
                                        />

                                        <RenderIf
                                            isTrue={ errors.email }
                                        >
                                            <FieldFeedback
                                                invalid
                                            >
                                                { errors.email?.join('\n') }
                                            </FieldFeedback>
                                        </RenderIf>
                                    </Field>
                                    <Field>
                                        <FieldLabel
                                            htmlFor='phone'
                                        >
                                            Phone (optional)
                                        </FieldLabel>

                                        <Input
                                            name='phone'
                                            type='tel'
                                            // placeholder='+1 (234) 567-8910'
                                            id='phone'
                                            mods={ { invalid: Boolean(errors.phone) } }
                                            inputProps={ { maxLength: 20 } }
                                        />

                                        <RenderIf
                                            isTrue={ errors.phone }
                                        >
                                            <FieldFeedback
                                                invalid
                                            >
                                                { errors.phone?.join('\n') }
                                            </FieldFeedback>
                                        </RenderIf>
                                    </Field>

                                    <Field>
                                        <FieldLabel
                                            htmlFor='organizationSize'
                                        >
                                            Organization Size*
                                        </FieldLabel>

                                        <Select
                                            name='organizationSize'
                                            id='organizationSize'
                                            mods={ { invalid: Boolean(errors.organizationSize) } }
                                            options={ organizationSizeOptions }
                                            required
                                        />

                                        <RenderIf
                                            isTrue={ errors.organizationSize }
                                        >
                                            <FieldFeedback
                                                invalid
                                            >
                                                { errors.organizationSize?.join('\n') }
                                            </FieldFeedback>
                                        </RenderIf>
                                    </Field>
                                </Grid>

                                <p
                                    className='desktop-body-4 text-neutral-700'
                                >
                                    By requesting a demo, I confirm that I have read and agree to <Link href='/legal/terms' mods={ { violet: true } }>Legal Terms</Link>.
                                </p>

                                <ReCAPTCHA
                                    ref={ recaptchaRef }
                                    sitekey={ process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY }
                                    size='invisible'
                                />

                                <RenderIf
                                    isTrue={ errors.recaptcha }
                                >
                                    <Alert
                                        severity='danger'
                                    >
                                        { errors.recaptcha?.join('\n') }
                                    </Alert>
                                </RenderIf>

                                <Button
                                    type='submit'
                                    variant='primary'
                                    mods={ { 'block': true, 'mt-8': true } }
                                    className='button_md'
                                >
                                    { loading ? <Loading/> : 'Request demo' }
                                </Button>
                            </form>
                        </div>

                        <div
                            className={ css(
                                'flex flex-col gap-8p',
                                '480:(gap-y-16p)',
                                '768:(flex-row)',
                                '1024:(flex-col gap-y-8p)'
                            ) }
                        >
                            <div className={ css(
                                'flex flex-col gap-8p',
                                '480:(flex-row)',
                                '1024:(flex-col)'
                            ) }>
                                <div
                                    className='flex flex-col items-center'
                                >
                                    <Picture
                                        image={ personalProductExpert }
                                        alt='You personal Product Expert'
                                        className='480:!w-144p 1024:!w-288p 1280:!w-320p'
                                    />

                                    <Icon
                                        name='quote'
                                        color={ 'green-900' }
                                        size={ 24 }
                                        mods={ {
                                            'bg-white': true
                                        } }
                                        className='w-24p h-24p box-content p-12p -mt-[9%] z-10 rounded-full'
                                    />
                                </div>

                                <div
                                    className={ css(
                                        'text-center pt-8p pb-16p',
                                        '480:(text-left px-16p)',
                                        '1024:(pt-0 px-20p text-center)',
                                        '1280:(px-24p)'
                                    ) }
                                >
                                    <h4
                                        className='mb-16p'
                                    >
                                        Not sure about the date and time yet? No problem, I'm totally flexible with it.
                                    </h4>

                                    <p className='desktop-subtitle'>
                                        Sebastian Ray
                                    </p>

                                    <p
                                        className='desktop-body-4 text-neutral-700'
                                    >
                                        You personal Product Expert
                                    </p>
                                </div>
                            </div>

                            <div
                                className={ css(
                                    'border-t h-fit border-neutral-300 pt-32p pb-8p',
                                    '768:(border-t-0 border-l pl-24p pt-16p)',
                                    '1024:(border-l-0 border-t pt-24p pb-0 px-20p whitespace-nowrap)',
                                    '1280:(px-24p)'
                                ) }
                            >
                                <div
                                    className='flex justify-center gap-x-16p mb-24p 768:mb-16p'
                                >
                                    { /* eslint-disable-next-line @next/next/no-img-element */ }
                                    <img
                                        src={ badge1 }
                                        alt='G2 Easiest Admin'
                                        className={ css(
                                            'max-w-none w-66p h-70p',
                                            '480:(w-88p h-94p)',
                                            '768:(w-56p h-60p)',
                                            '1024:(w-72p h-78p)'
                                        ) }
                                    />

                                    { /* eslint-disable-next-line @next/next/no-img-element */ }
                                    <img
                                        src={ badge2 }
                                        alt='G2 Users Love Us'
                                        className={ css(
                                            'max-w-none w-66p h-70p',
                                            '480:(w-88p h-94p)',
                                            '768:(w-56p h-60p)',
                                            '1024:(w-72p h-78p)'
                                        ) }
                                    />

                                    { /* eslint-disable-next-line @next/next/no-img-element */ }
                                    <img
                                        src={ badge3 }
                                        alt='G2 High Performer'
                                        className={ css(
                                            'max-w-none w-66p h-70p',
                                            '480:(w-88p h-94p)',
                                            '768:(w-56p h-60p)',
                                            '1024:(w-72p h-78p)'
                                        ) }
                                    />
                                </div>

                                <p className='desktop-subtitle text-center 768:text-left 1024:text-center'>
                                    More than 50,000 users trust Traqq
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

            <Reviews/>

            <RenderIf
                isTrue={ sent }
            >
                <MailResponse
                    title={ response.title }
                    body={ response.body }
                />
            </RenderIf>
        </>
    )
}

export default Demo
